var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show_seckill)?_c('div',{staticClass:"active_type"},[_c('div',{staticClass:"active_name"},[_vm._v("秒杀")]),_c('p',{staticClass:"count_tip",class:_vm.status == 2? '':'count_tip2'},[_vm._v(_vm._s(_vm.timer.hr)+":"+_vm._s(_vm.timer.min)+":"+_vm._s(_vm.timer.sec)+" "),_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }